import { Controller } from "@hotwired/stimulus"

// Inline edit controller: click text to reveal an input, blur/enter saves via PATCH.
// Usage:
//   data-controller="inline-edit"
//   data-inline-edit-url-value="/admin/notary_sessions/1"
//   data-inline-edit-field-value="notary_session[name]"
//   data-inline-edit-text-target="display"  → the visible text element
//   data-inline-edit-input-target="input"   → the hidden input
export default class extends Controller {
  static targets = ["display", "input"]
  static values  = { url: String, field: String }

  edit() {
    this.displayTarget.classList.add("d-none")
    this.inputTarget.classList.remove("d-none")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel() {
    this.inputTarget.value = this.displayTarget.dataset.value
    this.inputTarget.classList.add("d-none")
    this.displayTarget.classList.remove("d-none")
  }

  async save() {
    const value = this.inputTarget.value.trim()
    if (!value) { this.cancel(); return }

    const body = new FormData()
    body.append("_method", "patch")
    body.append(this.fieldValue, value)

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                   "Accept": "application/json" },
        body
      })

      if (response.ok) {
        this.displayTarget.textContent = value
        this.displayTarget.dataset.value = value
      } else {
        this.cancel()
      }
    } catch {
      this.cancel()
    }

    this.inputTarget.classList.add("d-none")
    this.displayTarget.classList.remove("d-none")
  }

  keydown(event) {
    if (event.key === "Enter")  { event.preventDefault(); this.save() }
    if (event.key === "Escape") { this.cancel() }
  }
}
